document.addEventListener("DOMContentLoaded", () => {

  /* ---------------------
     Sidebar Tabs
  --------------------- */

  document.querySelectorAll(".halo-menu-layout").forEach((menu) => {

    const buttons = menu.querySelectorAll(".halo-sidebar__button");
    const panels = menu.querySelectorAll(".halo-panel");

    buttons.forEach((button) => {

      button.addEventListener("mouseenter", () => {

        const tab = button.dataset.haloTab;

        buttons.forEach((b) =>
          b.classList.remove("is-active")
        );

        panels.forEach((p) =>
          p.classList.remove("is-active")
        );

        button.classList.add("is-active");

        menu
          .querySelector(`[data-halo-panel="${tab}"]`)
          ?.classList.add("is-active");

      });

      button.addEventListener("click", () => {

        const tab = button.dataset.haloTab;

        buttons.forEach((b) =>
          b.classList.remove("is-active")
        );

        panels.forEach((p) =>
          p.classList.remove("is-active")
        );

        button.classList.add("is-active");

        menu
          .querySelector(`[data-halo-panel="${tab}"]`)
          ?.classList.add("is-active");

      });

    });

  });

  /* ---------------------
     Swipers
  --------------------- */

  document.querySelectorAll(".halo-panel").forEach((panel) => {

    const swiperEl = panel.querySelector(".halo-swiper");
    const next = panel.querySelector(".halo-next");
    const prev = panel.querySelector(".halo-prev");

    new Swiper(swiperEl, {

      slidesPerView: 2,
      spaceBetween: 16,
      loop: true,

      grid: {
        rows: 2,
        fill: "row"
      },

      navigation: {
        nextEl: next,
        prevEl: prev
      },

      breakpoints: {

        990: {

          slidesPerView: 4,
          spaceBetween: 24,

          grid: {
            rows: 1
          }

        }

      }

    });

  });

});